import React, { useRef } from "react";
import usePlacesAutocomplete from "use-places-autocomplete";
import Input from "@components/input";
import { useTranslation } from "@components/translation-context/TranslationContext";
import './style.css'
import useOutsideClick from "../../hooks/useOutsideClick";
import Suggestion from "./components/suggestion";
import PlacesAutocompleteProps from "./props";
import requestReducer from "@reducers/requestReducer";
import { useRequest } from "../../context/requestContext";

const PlacesAutocomplete = (props: PlacesAutocompleteProps) => {
    // Attributes
    const {
        // setValue,
        value,
        screenConfig,
        errors,
        register,
        clearError
    } = props;

    const ref = useRef<any>();
    const { translate } = useTranslation();
    const { dispatch } = useRequest();

    const { suggestions: { data }, setValue, clearSuggestions } = usePlacesAutocomplete({
        requestOptions: {},
        debounce: 300,
    });

    //Hooks
    useOutsideClick(ref, clearSuggestions);

    // Handlers
    const handleInput = (e: any) => {
        setValue(e.target.value);
        const action = { type: requestReducer.actions.workerAddressChanged, payload: e.target.value };
        dispatch(action);
    };

    const handleSelect = ({ description }: any) => () => {
        const action = { type: requestReducer.actions.workerAddressChanged, payload: description };
        dispatch(action);
        clearSuggestions();
        clearError();
        props.setValue("workerAddress", description);
    };

    //Render
    return (
        <div ref={ref} className="autocomplete-container">
            <Input
                type="text"
                name="workerAddress"
                isHidden={false}
                value={value}
                setValue={props.setValue}
                onChange={(event) => handleInput(event)}
                placeholder={translate('addressPlaceholder')}
                error={errors.workerAddress}
                errorMessage={errors.workerAddress?.type === "pattern" ? translate('patternError') : translate('errorInput')}
                register={register}
                formProps={{ required: true }}
                style={{width: '100%'}}
            />

            <ul className="suggestionUl" style={{ width: (ref?.current?.clientWidth - 1) ?? "", display: data.length > 0 ? 'initial' : 'none' }}>
                {
                    data.map((suggestion) => <Suggestion suggestion={suggestion} handleSelect={handleSelect} />)
                }
            </ul>
        </div>
    );
};

export default PlacesAutocomplete;